import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: localStorage.getItem('users')
    ? JSON.parse(localStorage.getItem('users'))
    : null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload.users;
      localStorage.setItem('users', JSON.stringify(action.payload.users));
    },
  },
});

export const {setUsers } = usersSlice.actions;

export default usersSlice.reducer;
